import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_ace96276/src/layouts/default.vue").then(m => m.default || m))
}